import React from "react";
import { useTranslation } from "react-i18next";
import { isRegistrationOpen } from "../../utils/tinkerpreneur";

const ATLTinkerpreneurCTA = ({ year }) => {
  const { t } = useTranslation();
  const registrationOpen = isRegistrationOpen(year);
  return (
    <div className="d-flex align-items-center flex-column mt-3">
      <p className="text-center mt-4">
        {t("atl_tinkerpreneur.cta_description").replace("{year}", year)}
      </p>
      <div className={`d-flex flex-column align-items-center flex-md-row`}>
        {registrationOpen ? (
          <p className="text-center header border-0 px-md-4 mx-4 d-flex flex-column flex-md-row">
            <a
              href={"/signup"}
              className="header-link m-0 sign-up text-nowrap px-4 py-3"
            >
              {t("atl_tinkerpreneur.cta_button")}
            </a>
          </p>
        ) : (
          <p className="text-center header border-0 px-md-4 mx-4">
            <button
              disabled
              className="header-link m-0 sign-up danger text-nowrap px-4 py-3"
            >
              Submissions closed
            </button>
          </p>
        )}
      </div>
    </div>
  );
};

export default ATLTinkerpreneurCTA;
